export const MAX_FILES = 1;

export const ACCEPTED_MIME_TYPES_BY_EXTENSIONS = {
	'application/msword': ['.doc'],
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
		'.docx'
	],
	'image/jpeg': ['.jpg', '.jpeg'],
	'application/pdf': ['.pdf'],
	'image/png': ['.png'],
	'application/vnd.ms-powerpoint': ['.ppt'],
	'application/vnd.openxmlformats-officedocument.presentationml.presentation':
		['.pptx'],
	'image/svg+xml': ['.svg'],
	'application/vnd.ms-excel': ['.xls'],
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
		'.xlsx'
	]
};

export const acceptedTypesAsString = Object.keys(
	ACCEPTED_MIME_TYPES_BY_EXTENSIONS
).join(',');

export function getErrorCode(error) {
	const { status } = error || {};
	const { errorCode, code } = error?.data || {};
	const parsedCode = errorCode || code;

	if (!status) {
		return;
	}

	switch (status) {
		case 400:
			if (parsedCode === 'dimensions_exceeded') {
				return 'dimensionsExceeded';
			}
			return 'notFound';
		case 413:
			return 'maxSize';
		case 415:
			return 'unsupportedFormat';
		default:
	}
}
